<template>
  <div class="app-container">
    <div class="filter-container">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <h4>算力池配置</h4>
        </div>
        <el-table border :data="packageConfigList">
          <el-table-column label="一号池默认Token" align="center" prop="queueOneMaxToken">
          </el-table-column>
          <el-table-column label="二号池默认Token" align="center" prop="queueTwoMaxToken">
          </el-table-column>
          <el-table-column label="一号池匹配数量" align="center" prop="queueOneRatio">
          </el-table-column>
          <el-table-column label="二号池匹配数量" align="center" prop="queueTwoRatio">
          </el-table-column>
          <el-table-column label="匹配中增加虚人数区间" align="center">
            <template slot-scope="scope">
              {{ scope.row.unsuccessfulMinAddVirtual }} ~ {{ scope.row.unsuccessfulMaxAddVirtual }} 人
            </template>
          </el-table-column>
          <el-table-column label="匹配成功增加虚人数区间" align="center">
            <template slot-scope="scope">
              {{ scope.row.successfulMinAddVirtual }} ~ {{ scope.row.successfulMaxAddVirtual }} 人
            </template>
          </el-table-column>
          <el-table-column label="每日限购数量" align="center" prop="dailyOrderLimit">
          </el-table-column>
          <el-table-column label="操作" align="center">
            <el-link type="primary" @click="packageConfigEditDialog = true">编辑</el-link>
          </el-table-column>
        </el-table>
      </el-card>


      <div style="display: flex">
        <el-card class="box-card" style="width: 33%">
          <div slot="header" class="clearfix">
            <span style="font-size: 16px;font-weight: bold;color: #FFFFFF">待匹配池信息</span>
          </div>
          <el-table border :data="poolInfoList">
            <el-table-column label="昨日待入池总数" align="center" prop="yesterdayWaitInThePool">
            </el-table-column>
            <el-table-column label="当前待入池总数" align="center" prop="todayWaitInThePool">
            </el-table-column>
          </el-table>
          <el-table border :data="waitInList">
            <el-table-column label="日期" align="center" prop="createTime">
            </el-table-column>
            <el-table-column label="待入池总数" align="center" prop="unsuccessfulCount">
            </el-table-column>
          </el-table>
          <div style="display: flex;justify-content: center;margin-top: 10px">
            <el-pagination
                @size-change="waitInHandleSizeChange"
                @current-change="waitInHandleCurrentChange"
                :current-page="waitInToParams.current"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="waitInToParams.size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="waitInToTotal">
            </el-pagination>
          </div>
        </el-card>
        <el-card class="box-card" style="width: 33%">
          <div slot="header" class="clearfix">
            <span style="font-size: 16px;font-weight: bold;color: #FFFFFF">一号池信息</span>
            <el-button style="float: right; padding: 3px 0" type="text" @click="openTokenEdit(1)">修改一号入池限额
            </el-button>
          </div>
          <el-table border :data="poolInfoList">
            <el-table-column label="昨目匹配数量" align="center" prop="yesterdayInOnePool">
            </el-table-column>
            <el-table-column label="今日匹配数量" align="center" prop="todayWaitInTheOnePool">
            </el-table-column>
            <el-table-column label="匹配池入池限额数量" align="center" prop="oneTodayMaxToken">
            </el-table-column>
            <el-table-column label="匹配池剩余待匹配数量" align="center" prop="oneWaitCount">
            </el-table-column>
          </el-table>
          <el-table border :data="onePoolList">
            <el-table-column label="日期" align="center" prop="createTime">
            </el-table-column>
            <el-table-column label="未匹配数" align="center" prop="unsuccessfulCount">
            </el-table-column>
            <el-table-column label="已匹配数" align="center" prop="successfulCount">
            </el-table-column>
          </el-table>
          <div style="display: flex;justify-content: center;margin-top: 10px">
            <el-pagination
                @size-change="oneHandleSizeChange"
                @current-change="oneHandleCurrentChange"
                :current-page="onePoolParams.current"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="onePoolParams.size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="onePoolTotal">
            </el-pagination>
          </div>
        </el-card>
        <el-card class="box-card" style="width: 33%">
          <div slot="header" class="clearfix">
            <div slot="header" class="clearfix">
              <span style="font-size: 16px;font-weight: bold;color: #FFFFFF">二号池信息</span>
              <el-button style="float: right; padding: 3px 0" type="text" @click="openTokenEdit(2)">修改二号入池限额
              </el-button>
            </div>
          </div>
          <el-table border :data="poolInfoList">
            <el-table-column label="昨目匹配数量" align="center" prop="yesterdayInTwoPool">
            </el-table-column>
            <el-table-column label="今日匹配数量" align="center" prop="todayWaitInTheTwoPool">
            </el-table-column>
            <el-table-column label="匹配池入池限额数量" align="center" prop="twoTodayMaxToken">
            </el-table-column>
            <el-table-column label="匹配池剩余待匹配数量" align="center" prop="twoWaitCount">
            </el-table-column>
          </el-table>
          <el-table border :data="twoPoolList">
            <el-table-column label="日期" align="center" prop="createTime">
            </el-table-column>
            <el-table-column label="未匹配数" align="center" prop="unsuccessfulCount">
            </el-table-column>
            <el-table-column label="已匹配数" align="center" prop="successfulCount">
            </el-table-column>
          </el-table>
          <div style="display: flex;justify-content: center;margin-top: 10px">
            <el-pagination
                @size-change="twoInHandleSizeChange"
                @current-change="twoHandleCurrentChange"
                :current-page="twoPoolParams.current"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="twoPoolParams.size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="twoPoolTotal">
            </el-pagination>
          </div>
        </el-card>
      </div>

    </div>

    <el-dialog title="算力池配置" :visible.sync="packageConfigEditDialog" width="800px">
      <el-form ref="packageConfigEditForm" :model="packageConfigEdit" label-width="300px" size="small"
               :rules="packageConfigRules">
        <el-form-item label="一号池默认Token(个)" prop="queueOneMaxToken">
          <el-input-number size="small" style="width: 150px" :min="0" controls-position="right"
                           v-model="packageConfigEdit.queueOneMaxToken"></el-input-number>
        </el-form-item>
        <el-form-item label="二号池默认Token(个)" prop="queueTwoMaxToken">
          <el-input-number size="small" style="width: 150px" :min="0" controls-position="right"
                           v-model="packageConfigEdit.queueTwoMaxToken"></el-input-number>
        </el-form-item>
        <el-form-item label="一号池匹配数量(个)" prop="queueOneRatio">
          <el-input-number size="small" style="width: 150px" :min="0" controls-position="right"
                           v-model="packageConfigEdit.queueOneRatio"></el-input-number>
        </el-form-item>
        <el-form-item label="二号池匹配数量(个)" prop="queueTwoRatio">
          <el-input-number size="small" style="width: 150px" :min="0" controls-position="right"
                           v-model="packageConfigEdit.queueTwoRatio"></el-input-number>
        </el-form-item>
        <el-form-item label="匹配中增加虚人数区间(人数)" prop="unsuccessfulMinAddVirtual">
          <el-input-number size="small" style="width: 150px" :min="0" controls-position="right"
                           v-model="packageConfigEdit.unsuccessfulMinAddVirtual"></el-input-number>
          ~
          <el-input-number size="small" style="width: 150px" :min="0" controls-position="right"
                           v-model="packageConfigEdit.unsuccessfulMaxAddVirtual"></el-input-number>
          人
        </el-form-item>
        <el-form-item label="匹配成功增加虚人数区间(人数)" prop="successfulMinAddVirtual">
          <el-input-number size="small" style="width: 150px" :min="0" controls-position="right"
                           v-model="packageConfigEdit.successfulMinAddVirtual"></el-input-number>
          ~
          <el-input-number size="small" style="width: 150px" :min="0" controls-position="right"
                           v-model="packageConfigEdit.successfulMaxAddVirtual"></el-input-number>
          人
        </el-form-item>
        <el-form-item label="每日限购数量" prop="queueTwoRatio">
          <el-input-number size="small" style="width: 150px" :min="0" controls-position="right"
                           v-model="packageConfigEdit.dailyOrderLimit"></el-input-number>
        </el-form-item>
        <div style="text-align: right">
          <el-button @click="packageConfigEditDialog = false">取消</el-button>
          <el-button type="primary" @click="editPackageConfig">保存</el-button>
        </div>
      </el-form>

    </el-dialog>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
// 例如：import uploadFile from '@/components/uploadFile/uploadFile'

import {editPoolMaxTokenApi, getPageByPoolNumApi, getPoolInfoApi} from "@/api/packageSystemConfigApi";
import {getByConfigKey, updateDocumentConfig} from "@/api/basicConfig";

export default {
  name: 'packageSystemConfig',
  // import引入的组件需要注入到对象中才能使用
  components: {},
  props: {
    // patientIn: {
    //   type: Object,
    //   default () {
    //     return {}
    //   }
    // }
  },
  data() {
    // 这里存放数据
    return {
      editPackageConfigData: {},
      packageConfigList: [],
      packageConfigEdit: {
        "queueOneMaxToken": 2000,
        "queueTwoMaxToken": 1000,
        "queueOneRatio": 2,
        "queueTwoRatio": 1,
        "unsuccessfulMinAddVirtual": 0,
        "unsuccessfulMaxAddVirtual": 100,
        "successfulMinAddVirtual": 500,
        "successfulMaxAddVirtual": 1000,
        "dailyOrderLimit": 1000,
      },
      packageConfigEditDialog: false,
      packageConfigRules: {
        queueOneMaxToken: [
          {required: true, message: '请输入一号池默认Token(个)', trigger: 'blur'},
          {type: 'number', message: '一号池默认Token(个)必须为数字值', trigger: 'blur'}
        ],
        queueTwoMaxToken: [
          {required: true, message: '请输入二号池默认Token(个)', trigger: 'blur'},
          {type: 'number', message: '二号池默认Token(个)必须为数字值', trigger: 'blur'}
        ],
        queueOneRatio: [
          {required: true, message: '请输入一号池匹配数量(个)', trigger: 'blur'},
          {type: 'number', message: '一号池匹配数量(个)必须为数字值', trigger: 'blur'}
        ],
        queueTwoRatio: [
          {required: true, message: '请输入二号池匹配数量(个)', trigger: 'blur'},
          {type: 'number', message: '二号池匹配数量(个)必须为数字值', trigger: 'blur'}
        ],
        unsuccessfulMinAddVirtual: [
          {required: true, message: '请输入匹配中增加虚人数区间(人数)', trigger: 'blur'},
          {type: 'number', message: '匹配中增加虚人数区间(人数)必须为数字值', trigger: 'blur'}
        ],
        successfulMinAddVirtual: [
          {required: true, message: '请输入匹配成功增加虚人数区间(人数)', trigger: 'blur'},
          {type: 'number', message: '匹配成功增加虚人数区间(人数)必须为数字值', trigger: 'blur'}
        ]
      },
      poolInfoList: [],
      waitInList: [],
      waitInToTotal: 0,
      onePoolTotal: 0,
      twoPoolTotal: 0,
      onePoolList: [],
      twoPoolList: [],
      waitInToParams: {
        size: 10,
        current: 1,
        type: 0
      },
      onePoolParams: {
        size: 10,
        current: 1,
        type: 1
      },
      twoPoolParams: {
        size: 10,
        current: 1,
        type: 2
      }
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 方法集合
  methods: {
    waitInHandleSizeChange(val) {
      this.waitInToParams.size = val
      this.getWaitInList()
    },
    waitInHandleCurrentChange(val) {
      this.waitInToParams.current = val
      this.getWaitInList()
    },
    oneHandleSizeChange(val) {
      this.onePoolParams.size = val
      this.getOnePoolList()
    },
    oneHandleCurrentChange(val) {
      this.onePoolParams.current = val
      this.getOnePoolList()
    },
    twoInHandleSizeChange(val) {
      this.twoPoolParams.size = val
      this.getTwoPoolList()
    },
    twoHandleCurrentChange(val) {
      this.twoPoolParams.current = val
      this.getTwoPoolList()
    },
    async getPackageConfig() {
      this.packageConfigList = []
      let {data} = await getByConfigKey({configKey: "package_config"});
      this.packageConfigList.push(JSON.parse(data.configValue))
      this.packageConfigEdit = JSON.parse(data.configValue);
      this.editPackageConfigData = data
    },
    async getPoolInfo() {
      this.poolInfoList = []
      let {data} = await getPoolInfoApi();
      this.poolInfoList.push(data)
    },
    async getWaitInList() {
      let {data} = await getPageByPoolNumApi(this.waitInToParams);
      this.waitInToTotal = data.total
      this.waitInList = data.rows
    },
    async getOnePoolList() {
      let {data} = await getPageByPoolNumApi(this.onePoolParams);
      this.onePoolTotal = data.total
      this.onePoolList = data.rows
    },
    async getTwoPoolList() {
      let {data} = await getPageByPoolNumApi(this.twoPoolParams);
      this.twoPoolTotal = data.total
      this.twoPoolList = data.rows
    },

    openTokenEdit(pool) {
      this.$prompt('请输入调整数量', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[0-9]*[1-9][0-9]*$/,
        inputErrorMessage: '数量错误'
      }).then(({value}) => {
        this.$alert('你确认修改吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          callback: async (action) => {
            await editPoolMaxTokenApi({poolNum: pool, maxToken: value})
            await this.getPoolInfo()
          }
        });
      });
    },
    editPackageConfig() {
      this.$alert('你确认修改算力配置吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        callback: async () => {
          this.editPackageConfigData.configValue = JSON.stringify(this.packageConfigEdit)
          await updateDocumentConfig(this.editPackageConfigData)
          await this.getPackageConfig()
          this.packageConfigEditDialog = false
        }
      });
    }
  },
  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {

  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getPoolInfo()
    this.getPackageConfig()
    this.getWaitInList()
    this.getOnePoolList()
    this.getTwoPoolList()

  },
  beforeCreate() {
  }, // 生命周期 - 创建之前
  beforeMount() {
  }, // 生命周期 - 挂载之前
  beforeUpdate() {
  }, // 生命周期 - 更新之前
  updated() {
  }, // 生命周期 - 更新之后
  beforeDestroy() {
  }, // 生命周期 - 销毁之前
  destroyed() {
  }, // 生命周期 - 销毁完成
  activated() {
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped>
.app-container {
  padding: 20px;
}

.filter-container {
  padding: 20px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
}
</style>